// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6f47233a","239":"43fc5b31","453":"d452f861","455":"5c7f5ce1"}[chunkId] + ".chunk.js";
};